<template>
  <Dialog
    :visible="visible"
    modal
    :closable="false"
    :style="{ width: '500px' }"
    @update:visible="$emit('update:visible', $event)"
  >
    <template #header>
      <h3 class="text-lg font-semibold">Delete Benefit</h3>
    </template>

    <div class="space-y-3">
      <p v-if="isFixedAmount" class="text-gray-700">
        Since this benefit has a fixed amount, existing participants will keep
        access to their remaining benefits until they are used.
      </p>
      <p v-else class="text-gray-700">
        Existing participants will keep access to it, but it will not renew at
        their next billing cycle.
      </p>

      <p class="text-gray-700">New participants will no longer receive it.</p>

      <p class="text-gray-700">
        This action is permanent and cannot be undone.
      </p>
    </div>

    <template #footer>
      <div class="flex justify-end gap-3">
        <Button
          label="Go back"
          severity="secondary"
          outlined
          @click="$emit('update:visible', false)"
        />
        <Button
          label="Delete Benefit"
          severity="danger"
          @click="handleConfirm"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import type { LimitTypeEnum } from "@/api/model";

const props = defineProps<{
  visible: boolean;
  limitType?: LimitTypeEnum;
  benefitName?: string;
  hasActiveParticipants?: boolean;
}>();

const emit = defineEmits<{
  "update:visible": [value: boolean];
  confirm: [];
}>();

const isFixedAmount = computed(() => {
  return props.limitType?.toLowerCase() === "fixed";
});

function handleConfirm() {
  emit("confirm");
  emit("update:visible", false);
}
</script>
